import { render, staticRenderFns } from "./TipsSelector.vue?vue&type=template&id=9463584a&scoped=true&"
import script from "./TipsSelector.vue?vue&type=script&lang=ts&"
export * from "./TipsSelector.vue?vue&type=script&lang=ts&"
import style0 from "./TipsSelector.vue?vue&type=style&index=0&id=9463584a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9463584a",
  null
  
)

export default component.exports